<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Glastype</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="omschrijving">Omschrijving <sup>*</sup></label>
                                <input type="text" v-model="model.omschrijving" id="omschrijving" name="omschrijving" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('omschrijving') }" />
                                <span class="small text-danger" v-show="errors.has('omschrijving')">Omschrijving is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="coefficient">Coëfficiënt <sup>*</sup> <span class="small">(percentage)</span></label>
                                <input type="number" step=".01" min="0" max="999.99" v-model="model.coefficient" id="coefficient" name="coefficient" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('coefficient') }" />
                                <span class="small text-danger" v-show="errors.has('coefficient')">Coëfficiënt is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Form',
        props: ['model', 'isEditing'],
        methods: {
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/glastype/Form.vue